import api from '.';
import { Message, QuestionResponse } from '@karehero/models';

export const triageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    handleTriageResponses: builder.mutation<
      Message,
      { responses: QuestionResponse[]; careCircleID: string }
    >({
      query: ({ responses, careCircleID }) => ({
        url: `/triage/${careCircleID}/responses`,
        method: 'POST',
        body: responses,
      }),
      invalidatesTags: ['Triage'],
    }),
  }),
});

export const { useHandleTriageResponsesMutation } = triageApi;
